export const CITATION = {
  TEXT: `
    “Nós unimos juventude, tecnologia e experiência para
     gerar inovação com confiabilidade e excelência.”
  `
}
